'use client'
import { usePathname } from 'next/navigation'

import { SienaChatScript } from './SienaChatScript'

export const SienaChatScriptAppDirectory = () => {
  const pathname = usePathname()

  return pathname?.includes('/products/') || pathname?.includes('/kits/') ? (
    <SienaChatScript shiftWidgetUpMobile={true} />
  ) : (
    <SienaChatScript shiftWidgetUpMobile={false} />
  )
}
